import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import {
  Button,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  useTheme,
  ButtonProps
} from '@mui/material';
import InputSocialProfile from '../InputSocialProfile';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import InputPostLink from '../InputPostLink';
import { useAppSelector } from 'src/app/hooks';
import NotAllowedTooltip from '../NotAllowedTooltip';

interface Props {
  title: string;
  buttonProps?: ButtonProps;
  buttonLabel?: string;
}

const ModalAddPostLink: React.FC<Props> = ({
  title,
  buttonProps = {},
  buttonLabel
}) => {
  const [open, setOpen] = useState(false);
  const userRole = useAppSelector((state) => state.users.project.role);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const theme = useTheme();

  const isMember = userRole === 'member';

  return (
    <>
      {isMember ? (
        <NotAllowedTooltip>
          <Button
            variant="outlined"
            endIcon={<AddIcon />}
            {...buttonProps}
            sx={{ ...buttonProps.sx }}
          >
            {buttonLabel ? buttonLabel : 'Social Profile'}
          </Button>
        </NotAllowedTooltip>
      ) : (
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          endIcon={<AddIcon />}
          {...buttonProps}
          sx={{ ...buttonProps.sx }}
        >
          {buttonLabel ? buttonLabel : 'Social Profile'}
        </Button>
      )}
      <Dialog onClose={handleClose} open={open} fullWidth maxWidth={'md'}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            m: theme.spacing(3, 3, 0),
            p: theme.spacing(2, 3, 0, 3)
          }}
        >
          <Typography variant="h4">{title} </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            m: { xs: 0, sm: theme.spacing(1, 3) }
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="caption">
                Your quota is defined when your payment plan is purchased.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="h5">
                  Add {buttonLabel ? buttonLabel : 'Social Profile'}
                </Typography>
                <InputPostLink objectType="post_link" onClose={handleClose} />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalAddPostLink;
